import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import $ from "jquery";
import JsPDF from "jspdf";
import Papa from "papaparse";
import HtmlParser from "react-html-parser";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import * as Yup from "yup";
import CareerPicker from "../../careerLibrary/CareerPicker";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonLoaderBasic from "../../../loaders/SkeletonLoaderBasic";
import { GetNetsuiteProductListCancelToken } from "../../../services/ProgrammeServices";
import {
  AddProgram,
  GetAssignedProgrammeAndShortCourseList,
  GetDropdownForProgrammeAndShortCourse,
  GetListProgrammeAndShortCourse,
  GetPagesList,
  GetSchoolList,
  UpdateProgramme,
  getActiveVersionIds,
  getAssignedDropdownForPmc,
  getPagesListForPmcFilters
} from "../../../services/ProgramService";
import {
  modifiyOptionsForSelect
} from "../../../utils/commonFunction";
import {
  RenderProgrammeOrCourseType,
  RenderProgrammeType,
} from "../../../utils/CommonGroupingItem";
import {
  RenderPMCPageStatus,
  RenderPMCStatus,
  RenderPMCStatusCol
} from "../../../utils/CommonStatusItems";
import { mapBuildingsToApi, mapBuildingsToSelect } from "../../../utils/CampusBuildingsUtil";
import CampusBuildingMultiSelect from "../../common/CampusBuildingMultiSelect";
import { MultiSelectDropdown } from "../../common/FormFields";
import DataTableComponent from "../../common/DataTableComponent";
import DataTableComponentFrontPagination from "../../common/DataTableComponentFrontPagination";
import HtmlInputEditor from "../../common/HtmlInputEditor";
import { TrimText } from "../../common/TrimText";
import { TermPeriods } from "../../systemadministration/DataReactSelect";

const reRegFrequencyOptions = [
  { value: 0, label: "Semester Based" },
  { value: 1, label: "Annual" }
]
const statusArr = [
  {
    value: "Draft",
    label: HtmlParser(`<span className="red" title="Draft">Draft  </span> `),
  },
  {
    value: "New",
    label: HtmlParser(`<span className="skyblue" title="New"> New </span>`),
  },
  {
    value: "Final",
    label: HtmlParser(` <span className="green" title="Final">Final</span>`),
  },
  {
    value: "Approved",
    label: HtmlParser(
      `<span className="yellowshade" title="Approved">Approved</span>`
    ),
  },
  {
    value: "Inactive",
    label: HtmlParser(
      `<span className="blue" title="Inactive">Inactive</span>`
    ),
  }
];
//TODO: This should be DB driven in future.
const minAdmissionLevelOptions = [
  { value: "none", label: "None" },
  { value: "grade11", label: "Grade 11" },
  { value: "matric", label: "Matric" },
  { value: "certificate", label: "National Certificate" },
  { value: "diploma", label: "Diploma" },
  { value: "degree", label: "Bachelor’s Degree" },
  { value: "honours", label: "Honours Degree" },
];

const NQF_LevelArr = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
];

const ProgramDetail = ({ detail, setRefresh,setQAview }) => {
  const history = useHistory();
  const { id, type } = useParams();
  const [disabled, setDisabled] = useState(false);

  const [subjectContent, setSubjectContent] = useState("");
  const [admissionReq, setAdmissionReq] = useState("");
  const [accreditation, setAccreditation] = useState();
  const [articulationOption, setArticulationOption] = useState("");

  const [studyKit, setStudyKit] = useState("");
  const [careerOpportunity, setCareerOpportunity] = useState("");
  const [hardwareReq, setHardwareReq] = useState("");
  const [duration, setDuration] = useState("");
  const [regulatoryInfo, setRegulatoryInfo] = useState("");
  const [impNotes, setImpNotes] = useState("");
  const [editorToShow, setEditorToShow] = useState(false);

  const [schoolList, setSchoolList] = useState([]);
  const [netsuiteProdList, setNetsuiteProdList] = useState([]);
  const [activeVersionList, setActiveVersionList] = useState([]);

  const [allpageListData, setAllPageListData] = useState([]);
  const [assignPageList, setAssignPageList] = useState([]);
  const [assignPageLoading, setAssignPageLoading] = useState(false);
  const [pageStatus, setPageStatus] = useState({ arr: [], checkObj: {} });
  const [pageBrand, setPageBrand] = useState({ arr: [], checkObj: {} });
  const [loading, setLoading] = useState(false);
  const [PageFilterData, setPageFilterdata] = useState({
    status: [],
    BrandList: [],
  });
  const [assignPageTableState, setAssignPageTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "PageTitle",
    sortOrder: "asc",
  });
  const [assignPageSearch, setAssignPageSearch] = useState("");
  const [assignPageTotalRows, setAssignPageTotalRows] = useState(0);

  const [articulationOptionList, setArticulationOptionList] = useState([]);
  const [articulationOptionLoading, setArticulationOptionLoading] =
    useState(false);
  const [articulationOptionSearch, setArticulationOptionSearch] = useState("");
  const [articulationOptionTotalRow, setArticulationOptionTotalRow] =
    useState("");
  const [articulationOptionTableState, setArticulationOptionTableState] =
    useState({
      page: 1,
      perPage: 10,
      sortKey: "name",
      sortOrder: "asc",
    });
  const [artStatus, setArtStatus] = useState({ arr: [], checkObj: {} });
  const [artProgType, setArtProgType] = useState({ arr: [], checkObj: {} });
  const [articulationOptionFilterData, setArticulationOptionFilterData] =
    useState({ status: [], programmeType: [], type: [] });
  const [artType, setArtType] = useState({ arr: [], checkObj: {} });

  const [assignedDataList, setAssignedDataLis] = useState([])
  const [assignedArticulationOptionList, setAssignedArticulationOptionList] =
    useState([]);
  const [assignedArticulationSearch, setAssignedArticulationSearch] =
    useState("");
  const [assignedStatus, setAssignedStatus] = useState({
    arr: [],
    checkObj: {},
  });
  const [assignedProgType, setAssignedProgType] = useState({
    arr: [],
    checkObj: {},
  });
  const [assignedType, setAssignedType] = useState({ arr: [], checkObj: {} });
  const [
    assignedArticulationOptionFilterData,
    setAssignedArticulationOptionFilterData,
  ] = useState({ AssignStatus: [], AssignProgrammeType: [], AssignType: [] });
  const [updateData, setUpdateData] = useState(false);

  const dropDownValues = useSelector((state) => state.registerDropdownValues);
  
  useEffect(() => {
    const cancelTokenSources = [];
    const cancelDropdownSource1 = [];
    const cancelDropdownSource2 = [];
    const cancelDropdownSource3 = [];
    const cancelDropdownSource4 = [];
    const cancelDropdownSource5 = [];
    const cancelDropdownSource6 = [];

    const getSchool = async () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("New request made");
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const res = await GetSchoolList();
        if (res.status == 200) {
          setSchoolList(res.data.data);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    const getNetsuiteProductData = async () => {
      cancelDropdownSource2.forEach((source) => {
        source.cancel("New request made");
      });
      const source2 = axios.CancelToken.source();
      cancelDropdownSource2.push(source2);

      try {
        const res = await GetNetsuiteProductListCancelToken("", source2.token);
        if (res.status == 200) {
          const respData =
            res.data.data && res.data.data.items ? res.data.data.items : [];
          const modifyResponse = modifiyOptionsForSelect(respData, "netsuite");
          setNetsuiteProdList(modifyResponse);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    const getPageFilters = async () => {
      cancelDropdownSource6.forEach((source) => {
        source.cancel("New request made");
      });
      const source3 = axios.CancelToken.source();
      cancelDropdownSource6.push(source3);

      try {
        const res = await getPagesListForPmcFilters(source3.token);
        if (res.status == 200) {
          setPageFilterdata({
            BrandList: res.data?.getBrandtemplate,
            status: res.data?.getStatus,
          });
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    getSchool();
    getNetsuiteProductData();
    getPageFilters();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("Component unmounted");
      });
      cancelDropdownSource1.forEach((source) => {
        source.cancel("Component unmounted");
      });
      cancelDropdownSource2.forEach((source) => {
        source.cancel("Component unmounted");
      });
      cancelDropdownSource3.forEach((source) => {
        source.cancel("Component unmounted");
      });
      cancelDropdownSource4.forEach((source) => {
        source.cancel("Component unmounted");
      });
      cancelDropdownSource5.forEach((source) => {
        source.cancel("Component unmounted");
      });
    };
  }, [type]);

  const fetchActiveVersion = async (id) => {
    try {
      const res = await getActiveVersionIds(id)
      setActiveVersionList(res?.data?.getVersionDropdown)
    } catch (error) {
      console.log("error", error)
    }
  }

  useEffect(() => {
    if (id)
      fetchActiveVersion(id)
  }, [id]);


  useEffect(() => {
    const cancelTokenSources = [];

    const getAssignPageListData = async () => {
      setAssignPageLoading(true);
      cancelTokenSources.forEach((source) => {
        source.cancel("New request made");
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const payload = {
          page: assignPageTableState.page,
          perPage: assignPageTableState.perPage,
          search: assignPageSearch,
          key: assignPageTableState.sortKey,
          sort: assignPageTableState.sortOrder,
          exportStatus: false,
          setSearch: setAssignPageSearch,
          viaBrand: pageBrand.arr,
          viaStatus: pageStatus.arr,
        };
        const res = await GetPagesList(payload, source.token);
        if (res.status == 200) {
          setAssignPageTotalRows(res.data?.Data?.total);
          setAssignPageList(res.data?.Data?.data);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      } finally {
        setAssignPageLoading(false);
      }
    };

    getAssignPageListData();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("Component unmounted");
      });
    };
  }, [assignPageTableState, assignPageSearch, pageStatus, pageBrand]);

  useEffect(() => {
    if (detail) {
      setSubjectContent(detail.Description);
      setAdmissionReq(detail.admission_req);
      setAccreditation(detail.accreditation);
      setArticulationOption(detail.articultion_option);
      setCareerOpportunity(detail.career_opportunities);
      setStudyKit(detail.study_kit);
      setHardwareReq(detail.hardware_requirement);
      setDuration(detail.duration_dec);
      setRegulatoryInfo(detail.regulatory_inform);
      setImpNotes(detail.important_notes);
      setEditorToShow(true);
    }
  }, [detail]);
  
  usePermissionGuardRedirect(['pmcpedit']);
  
  useEffect(() => {
    setLoading(true);
    if (type == "open" || type == "duplicate") {
      const payload = {
        id: id,
        exportStatus: "true",
        type_assigned: 0,
        viaProgrammeType: assignedProgType.arr,
        viaType: assignedType.arr,
        viaStatus: assignedStatus.arr,
      };
      GetAssignedProgrammeAndShortCourseList(payload)
        .then((res) => {
          if (res.status === 200) {
            const respData = res.data.data;
            setAssignedArticulationOptionList(respData.resData);
            const assignedData = respData.resData?.map(
              ({ id, type, pmc_type }) => ({
                id,
                pmc_type: type || pmc_type,
              })
            );
            setAssignedDataLis(assignedData)
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }, [id, updateData]);

  useEffect(() => {
    const payload = {
      page: articulationOptionTableState.page,
      limit: articulationOptionTableState.perPage,
      key: articulationOptionTableState.sortKey,
      sort: articulationOptionTableState.sortOrder,
      exportStatus: false,
      search: articulationOptionSearch,
      viaStatus: artStatus.arr,
      viaType: artType.arr,
      viaProgrammeType: artProgType.arr,
      id: id,
    };
    setArticulationOptionLoading(true);
    GetListProgrammeAndShortCourse(payload)
      .then((res) => {
        if (res.status === 200) {
          const respData = res.data.data;
          setArticulationOptionList(respData.resData);
          setArticulationOptionTotalRow(respData.pagination.total);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setArticulationOptionLoading(false);
      });
  }, [
    articulationOptionTableState,
    artType,
    artProgType,
    artStatus,
    articulationOptionSearch,
    id,
  ]);

  useEffect(() => {
    GetDropdownForProgrammeAndShortCourse().then((res) => {
      if (res.status === 200) {
        const respData = res.data;
        setArticulationOptionFilterData({
          ...res.data,
          status: respData.status,
          programmeType: respData.programmeType,
          type: respData.type,
        });
      }
    });

    if (type == "open" || type == "duplicate") {
      getAssignedDropdownForPmc({
        id: id,
        type_assigned: 0,
      })
        .then((res) => {
          if (res.status === 200) {
            const respData = res.data;
            setAssignedArticulationOptionFilterData({
              ...res.data,
              AssignStatus: respData.status,
              AssignProgrammeType: respData.programmeType,
              AssignType: respData.type,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [updateData]);
  
  const formik = useFormik({
    enableReinitialize: type === "open" || type === "duplicate" ? true : false,
    initialValues: {
      duplicateId: "",
      name: detail?.name ? detail?.name : "",
      saqa_id: detail?.saqa_id ? detail.saqa_id : "",
      SAQA_Name: detail?.SAQA_Name ? detail.SAQA_Name : "",
      School: detail?.School ? detail.School : "",
      qualification_type: detail?.qualification_type
        ? detail?.qualification_type
        : "",
      Code: detail?.Code ? detail.Code : "",
      SAQA_Link: detail?.SAQA_Link ? detail.SAQA_Link : "",
      NQF_Level: detail?.NQF_Level ? detail.NQF_Level : "",
      min_admission_level: detail?.min_admission_level ? detail.min_admission_level : "",
      Delivery_Methods: detail?.getLearningMethods
        ? detail?.getLearningMethods?.map((el) => el?.learning_method)
        : [],
      campusBuildings: detail?.campusBuildings ? mapBuildingsToSelect(detail.campusBuildings) : [],
      brandID: detail?.getBrandID
        ? detail.getBrandID?.map((el) => el?.brand_id)
        : [],
      FTMax: detail?.FTMax ? detail.FTMax : 0,
      FTMin: detail?.FTMin ? detail.FTMin : 0,
      PTMax: detail?.PTMax ? detail.PTMax : 0,
      PTMin: detail?.PTMin ? detail.PTMin : 0,
      Credits: detail?.Credits ? detail.Credits : "",
      Duration: detail?.Duration ? detail.Duration : "",
      Term_Period: detail?.Term_Period ? detail.Term_Period : "",
      version_id: detail?.version_id ? detail.version_id : "",

      netsuite_product: detail?.netsuite_product ? detail.netsuite_product : "",
      netsuite_department_id: detail?.netsuite_department_id ? detail.netsuite_department_id : "",
      status: detail?.status ? detail.status : "",
      popupID: detail?.popupID ? detail.popupID : "",
      auto_generate_fectsheet: detail?.auto_generate_fectsheet
        ? detail?.auto_generate_fectsheet == 1
        : false,
      override_default_tc: detail?.override_default_tc
        ? detail?.override_default_tc == 1
        : false,
      EnableStudypathLink: detail?.EnableStudypathLink ? detail?.EnableStudypathLink == 1 : false,
      EnableStudypathLinkReReg: detail?.EnableStudypathLinkReReg ? detail?.EnableStudypathLinkReReg == 1 : false,
      articulationMandatory: detail?.articulationMandatory ? detail?.articulationMandatory == 1 : false,
      terms_conditions_page: detail?.terms_conditions_page
        ? detail?.terms_conditions_page
        : "",
      terms_conditions_page_type: detail?.terms_conditions_page_type
        ? detail?.terms_conditions_page_type
        : "",

      Description: "",
      admission_req: "",
      accreditation: "",

      articultion_option: "",
      articulation_assign: assignedDataList,

      career_opportunities: "",
      study_kit: "",
      reRegFrequency: detail?.reRegFrequency ? detail.reRegFrequency : 0,
      hardware_requirement: "",
      core_spec: detail?.core_spec ? detail?.core_spec : 0,
      med_spec: detail?.med_spec ? detail?.med_spec : 0,
      high_spec: detail?.high_spec ? detail?.high_spec : 0,

      full_time_hybrid_fee: detail?.full_time_hybrid_fee
        ? detail?.full_time_hybrid_fee
        : "",
      full_time_online_fee: detail?.full_time_online_fee
        ? detail?.full_time_online_fee
        : "",
      part_time_online_fee: detail?.part_time_online_fee
        ? detail?.part_time_online_fee
        : "",
      registration_fee: detail?.registration_fee
        ? detail?.registration_fee
        : "",
      cost_terms: detail?.cost_terms ? detail?.cost_terms : "",
      installments: detail?.installments ? detail?.installments : "",
      earlyBirds:
        (type === "open" || type == "duplicate") && detail?.earlyBirds !== "" ? detail?.earlyBirds : 2,

      duration_dec: "",
      regulatory_inform: "",
      important_notes: "",

      conversion_code: detail?.conversion_code ? detail?.conversion_code : "",
      meta_title: detail?.meta_title ? detail?.meta_title : "",
      meta_description: detail?.meta_description
        ? detail?.meta_description
        : "",
      meta_keywords: detail?.meta_keywords ? detail?.meta_keywords : "",
    },
    validationSchema: Yup.object({
      PTMax: Yup.number().when("EnableStudypathLinkReReg", {
        is: true,
        then: Yup.number().when("PTMin", (PTMin, schema) =>
          schema.test(
            "pt-max-check",
            "Maximum PT must be more than Minimum PT",
            function (value) {
              if (value === 0) return true;
              return value >= PTMin;
            }
          )
        ),
        otherwise: Yup.number().notRequired(),
      }),
      FTMax: Yup.number().when("EnableStudypathLinkReReg", {
        is: true,
        then: Yup.number().when("FTMin", (FTMin, schema) =>
          schema.test(
            "ft-max-check",
            "Maximum FT must be more than Minimum FT",
            function (value) {
              if (value === 0) return true;
              return value >= FTMin;
            }
          )
        ),
        otherwise: Yup.number().notRequired(),
      }),
      name: Yup.string()
        .required("Programme Name is required")
        .max(255, "Programme Name should not be greater than 255 Character")
        .trim(),
      SAQA_Name: Yup.string()
        .required("SAQA Name is required")
        .max(255, "SAQA Name should not be greater than 255 Character")
        .trim(),
      School: Yup.string().required("School is required").trim(),
      qualification_type: Yup.string().required(
        "Qualification Type is required"
      ),
      NQF_Level: Yup.number()
        .typeError("NQF Level must be number")
        .min(1, "NQF can be 1 minimum")
        .max(10, "NQF can be 10 maximum")
        .required("NQF_Level is required"),
      Delivery_Methods: Yup.string()
        .required("Learning Methods is required")
        .trim(),
      status: Yup.string().required("Review Status is required"),
      version_id: Yup.number().when("EnableStudypathLinkReReg", {
        is: (val) =>
          (type === "open" || type === "duplicate") && val === true && activeVersionList?.length > 0,
        then: (schema) =>
          schema.required("Active Version is required"),
        otherwise: (schema) =>
          schema.notRequired().nullable(),
      })
    }),
    onSubmit: (values) => {
      setDisabled(true);
      const formData = new FormData();

      formData.append("name", values.name);
      formData.append("SAQA_Name", values.SAQA_Name);
      formData.append("saqa_id", values.saqa_id);
      formData.append("School", values.School);
      formData.append("qualification_type", values.qualification_type);
      formData.append("Code", values.Code);
      formData.append("SAQA_Link", values.SAQA_Link);
      formData.append("NQF_Level", values.NQF_Level);
      formData.append("min_admission_level", values.min_admission_level);
      values.Delivery_Methods.forEach((val, idx) => {
        formData.append(`${"Delivery_Methods"}[${idx}]`, val);
      });
      formData.append('reRegFrequency', values.reRegFrequency || 0);
      formData.append("Credits", values.Credits);
      formData.append("Duration", values.Duration);
      formData.append("FTMax", Number(values.FTMax || 0));
      formData.append("FTMin", Number(values.FTMin || 0));
      formData.append("PTMax", Number(values.PTMax || 0));
      formData.append("PTMin", Number(values.PTMin || 0));
      formData.append("Term_Period", values.Term_Period);
      formData.append("version_id", values.version_id);
      formData.append("campusBuildings", JSON.stringify(mapBuildingsToApi(values.campusBuildings)));
      formData.append("netsuite_product", values.netsuite_product);
      values.brandID.forEach((val, idx) => {
        formData.append(`${"brandID"}[${idx}]`, val);
      });
      formData.append("status", values.status);
      formData.append("publish_status", values.publish_status);
      formData.append("popupID", values.popupID);
      formData.append(
        "override_default_tc",
        values.override_default_tc == true ? 1 : 0
      );
      formData.append(
        "EnableStudypathLink",
        values.EnableStudypathLink == true ? 1 : 0
      );
      formData.append(
        "EnableStudypathLinkReReg",
        values.EnableStudypathLinkReReg == true ? 1 : 0
      )
      formData.append("articulationMandatory", values.articulationMandatory == true ? 1 : 0);
      formData.append("terms_conditions_page", values.terms_conditions_page);

      formData.append("Description", subjectContent);
      formData.append("admission_req", admissionReq);
      formData.append("accreditation", accreditation);
      formData.append("articultion_option", articulationOption);
      formData.append(
        "articulation_assign",
        JSON.stringify(values.articulation_assign)
      );
      formData.append("career_opportunities", careerOpportunity);
      formData.append("study_kit", studyKit);
      formData.append("hardware_requirement", hardwareReq);
      formData.append("core_spec", values.core_spec);
      formData.append("med_spec", values.med_spec);
      formData.append("high_spec", values.high_spec);
      formData.append("full_time_hybrid_fee", values.full_time_hybrid_fee);
      formData.append("full_time_online_fee", values.full_time_online_fee);
      formData.append("part_time_online_fee", values.part_time_online_fee);
      formData.append("registration_fee", values.registration_fee);
      formData.append("cost_terms", values.cost_terms);
      formData.append("installments", values.installments);
      formData.append(
        "earlyBirds",
        values.earlyBirds === "" ? 2 : values.earlyBirds
      );
      formData.append("duration_dec", duration);
      formData.append("regulatory_inform", regulatoryInfo);
      formData.append("important_notes", impNotes);
      formData.append("conversion_code", values.conversion_code);
      formData.append("meta_title", values.meta_title);
      formData.append("meta_description", values.meta_description);
      formData.append("meta_keywords", values.meta_keywords);
      formData.append(
        "terms_conditions_page_type",
        values.terms_conditions_page_type
      );
      formData.append("netsuite_department_id", values?.netsuite_department_id);
      if (id && type !== "duplicate") {
        formData.append("programId", id);
        UpdateProgramme(formData)
        .then((res) => {
          setDisabled(false);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Updated Successfully",
          });
          setRefresh(Date.now())

          if (!values.EnableStudypathLinkReReg) {
            setQAview(false)
          }
          setUpdateData(!updateData)
        })
          .catch((err) => {
            if (err.response?.data?.id) {
              Swal.fire({
                icon: "error",
                title: "Error",
                html: `
                    PMC Programme already exists with specified Netsuite ID<br/>
                    <a 
                        href="/program-management-center/programmes/programme/open/${err.response?.data?.id
                  }" 
                        className="customClass" 
                        title="${err.response?.data?.name
                    ? err.response.data.name
                      .trim()
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;")
                    : ""
                  }" 
                        autofocus
                    >
                        ${err.response?.data?.name
                    ? err.response.data.name
                      .trim()
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;")
                    : "Unnamed"
                  }
                    </a>
                `,
              });
              setDisabled(false);
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: err?.response?.data?.message || "Something went wrong",
              });
              setDisabled(false);
            }
          })
      } else {
        if (type == "duplicate") {
          formData.append("duplicateId", id);
        }
        AddProgram(formData)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Added Successfully",
            });
            history.push(
              `/program-management-center/programmes/programme/table`
            );
          })
          .catch((err) => {
            if (err.response?.data?.id) {
              Swal.fire({
                icon: "error",
                title: "Error",
                html: `
                    PMC Programme already exists with specified Netsuite ID<br>
                    <a 
                        href="/program-management-center/programmes/programme/open/${err.response?.data?.id
                  }" 
                        className="customClass" 
                        title="${err.response?.data?.name
                    ? err.response.data.name
                      .trim()
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;")
                    : ""
                  }" 
                        autofocus
                    >
                        ${err.response?.data?.name
                    ? err.response.data.name
                      .trim()
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;")
                    : "Unnamed"
                  }
                    </a>
                `,
              });
              setDisabled(false);
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: err?.response?.data?.message || "Something went wrong",
              });
              setDisabled(false);
            }
          });
      }
    },
  });

  useEffect(() => {
    if (id && formik.values?.EnableStudypathLinkReReg) {
      fetchActiveVersion(id)
    }
  }, [id, formik.values.EnableStudypathLinkReReg])

useEffect(() => {
  const data = netsuiteProdList.filter((item) => item.value == formik.values?.netsuite_product);
  const netsuit_dId = data[0]?.departmentId;
  
  if (netsuit_dId) {
    formik.setFieldValue("netsuite_department_id", netsuit_dId);
  }
}, [netsuiteProdList, formik.values?.netsuite_product]);



  const handleChangeInstallments = (value) => {
    const prevValue = formik.values.installments
      .split(",")
      .filter((item) => item != "");
    if (prevValue.includes(value)) {
      const ind = prevValue.findIndex((item) => item == value);
      prevValue.splice(ind, 1);
    } else {
      prevValue.push(value);
    }
    formik.setFieldValue("installments", prevValue.join(","));
  };

  const handlereset = async () => {
    history.push(`/program-management-center/programmes/programme/table`);
  };

  const assignPageColumn = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortField: "PageTitle",
      cell: (row) => (
        <span
          className="as-text-blue curser feature-name"
          onClick={() => {
            formik.setFieldValue("terms_conditions_page", row.PageID);
            $("#assignPagePopup").modal("hide");
          }}
          title={row.title}
        >
          <span className="textLimit100">
            {row.PageTitle ? row.PageTitle : "-"}
          </span>
        </span>
      ),
    },
    {
      name: "Status",
      selector: "Status",
      sortField: "status",
      sortable: true,
      cell: (row) => (row.status ? RenderPMCStatusCol(row.status).html : "-"),
    },
    {
      name: "Brand Templates",
      selector: "Brand Templates",
      sortable: false,
      cell: (row) => (
        <div>
          <div className="d-flex flex-wrap">
            {row?.brandTemplete?.length > 0
              ? row?.brandTemplete.map(
                (brand, index) =>
                  brand?.templateName && (
                    <div key={row.title + "_" + index} className="brandList-pmc" title={brand?.templateName}>
                      {brand?.templateName}
                    </div>
                  )
              )
              : "-"}
          </div>
        </div>
      ),
    },
    {
      name: "Action",
      selector: "",
      maxWidth: "50px",
      cell: (row) => (
        <div className="assessment-08">
          <div className="as-buttons">
            {formik.values.terms_conditions_page != row?.PageID ? (
              <button
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={() => {
                  formik.setFieldValue("terms_conditions_page", row?.PageID);
                  formik.setFieldValue(
                    "terms_conditions_page_type",
                    row?.PageTitle
                  );
                  $("#assignPagePopup").modal("hide");
                }}
                title="Assign Page"
              >
                <i className="fal fa-plus"></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger rounded-circle"
                onClick={() => {
                  formik.setFieldValue("terms_conditions_page", "");
                  formik.setFieldValue("terms_conditions_page_type", "");
                }}
                title="Assign Page"
              >
                <i className="fal fa-minus"></i>
              </button>
            )}
          </div>
        </div>
      ),
    },
  ]);

  const dataToRender = () => {
    let updatedData = [];
    let allData = [...assignedArticulationOptionList];

    if (assignedArticulationSearch.length) {
      let name = allData.filter((item) => {
        let includes = item.name
          ?.toString()
          ?.toLowerCase()
          ?.includes(assignedArticulationSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...name];
      let unique = [...new Set(data)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (assignedStatus.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = assignedStatus.arr.find(function (post, index) {
          if (
            item.status && post.toLowerCase() == item.status.toLowerCase()
              ? item.status
              : ""
          )
            return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedProgType.arr.length) {
      let tempProgType = updatedData;
      let tempResult = tempProgType.filter((item) => {
        const startsWith = assignedProgType.arr.find(function (post, index) {
          if (
            item.qualification_type && post == item.qualification_type
              ? item.qualification_type
              : ""
          )
            return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedType.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = assignedType.arr.find(function (post, index) {
          if (
            item?.pmc_type?.toString() &&
            post ==
            (item?.pmc_type?.toString() ? item?.pmc_type?.toString() : "")
          )
            return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (
      assignedArticulationSearch.length ||
      assignedStatus.arr.length ||
      assignedProgType.arr.length ||
      assignedType.arr.length
    ) {
      const uniqueData = updatedData.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id == value.id && t?.pmc_type == value?.pmc_type && t?.type == value?.type
        ))
      );

      return uniqueData;
    } else {
      const uniqueData = allData.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id == value.id && t?.pmc_type == value?.pmc_type && t?.type == value?.type
        ))
      );
      return uniqueData;
    }
  };

  const dataToRenderArticulationAssign = () => {
    let updatedData = [];
    let allData = assignedArticulationOptionList;
    if (assignedArticulationSearch.length) {
      let name = allData.filter((item) => {
        let includes = item.name
          .toString()
          .toLowerCase()
          .includes(assignedArticulationSearch.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...name];
      let unique = [...new Set(data)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }
    if (assignedStatus.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = assignedStatus.arr.find(function (post, index) {
          if (item.status && post.toLowerCase() == item.status.toLowerCase() ? item.status : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (assignedProgType.arr.length) {
      let tempProgType = updatedData;
      let tempResult = tempProgType.filter((item) => {
        const startsWith = assignedProgType.arr.find(function (post, index) {
          if (item.qualification_type && post == item.qualification_type ? item.qualification_type : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }
    if (assignedType.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = assignedType.arr.find(function (post, index) {
          if (item.type && post == item.type ? item.type : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });
      updatedData = tempResult;
    }

    if (assignedStatus.arr.length || assignedProgType.arr.length || assignedType.arr.length || articulationOptionSearch.length) {
      return updatedData;
    } else {
      return allData;
    }
  };

  const exportDataAssignedArticulationOption = () => {
    let data = dataToRender();
    const header = ["Name", "Code", "Status", "Programme Type", "Type"];
    data = data.map((row) => ({
      Name: row?.name ? row?.name : "-",
      Code: row.Code ? row.Code : "-",
      Status: row.status ? row.status : "-",
      "Programme Type": row.qualification_type
        ? RenderProgrammeType(row?.qualification_type).text
        : "-",
      Type:
        row?.pmc_type !== null && row?.pmc_type !== undefined
          ? RenderProgrammeOrCourseType(row.pmc_type).text
          : row?.type !== null && row?.type !== undefined
            ? RenderProgrammeOrCourseType(row.type).text
            : "-",
    }));
    const pdfData = data.map((row) => {
      return [
        row["Name"],
        row["Code"],
        row["Status"],
        row["Programme Type"],
        row["Type"],
      ];
    });
    return {
      header,
      data,
      pdfData,
      columnStyles: {},
    };
  };

  const exportDataArticulationOption = (fileType, fileName) => {
    let exportData = [...articulationOptionList];
    const header = ["Name", "Code", "Status", "Programme Type", "Type"];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    const payload = {
      page: articulationOptionTableState.page,
      limit: articulationOptionTableState.perPage,
      key: articulationOptionTableState.sortKey,
      sort: articulationOptionTableState.sortOrder,
      exportStatus: true,
      search: articulationOptionSearch,
      viaStatus: artStatus.arr,
      viaType: artType.arr,
      viaProgrammeType: artProgType.arr,
      id: id,
    };

    GetListProgrammeAndShortCourse(payload)
      .then((res) => {
        exportData = res.data.data?.resData;
        exportData = exportData?.map((row) => ({
          ...row,
          Name: row?.name ? row?.name : "-",
          Code: row.Code ? row.Code : "-",
          Status: row.status ? row.status : "-",
          "Programme Type": row.qualification_type
            ? RenderProgrammeType(row?.qualification_type).text
            : "-",
          Type:
            row?.pmc_type !== null && row?.pmc_type !== undefined
              ? RenderProgrammeOrCourseType(row.pmc_type).html
              : row?.type !== null && row?.type !== undefined
                ? RenderProgrammeOrCourseType(row.type).text
                : "-",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, exportData });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);

          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = exportData.map((row) => {
            const obj = {};
            header.forEach((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = exportData.map((row) => {
            return [
              row["Name"],
              row["Code"],
              row["Status"],
              row["Programme Type"],
              row["Type"],
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const articulationOptionColumn = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortField: "name",
      cell: (row) => (
        <span className="as-text-blue curser feature-name" title={row.name}>
          <span className="textLimit100">{row.name ? row.name : "-"}</span>
        </span>
      ),
    },
    {
      name: "Code",
      selector: "code",
      sortable: true,
      sortField: "code",
      cell: (row) => (row.Code ? row.Code : "-"),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      sortField: "status",
      cell: (row) =>
        row.status != null ? RenderPMCStatus(row.status).html : "-",
    },
    {
      name: "Programme Type",
      selector: "qualification_type",
      sortable: true,
      sortField: "qualification_type",
      cell: (row) =>
        row.qualification_type != null
          ? RenderProgrammeType(row.qualification_type).html
          : "-",
    },
    {
      name: "Type",
      selector: "type",
      sortable: true,
      sortField: "type",
      cell: (row) =>
        row.type != null ? RenderProgrammeOrCourseType(row.type).html : "-",
    },
    {
      name: "Action",
      selector: "",
      maxWidth: "50px",
      cell: (row) => {
        const isAssigned = assignedArticulationOptionList.some(
          (item) =>
            item.id === row.id &&
            (item.type || item.pmc_type) == (row.type || row.pmc_type)
        );
        const handleAssign = () => {
          setAssignedArticulationOptionList((prevList) => {
            const updatedList = isAssigned
              ? prevList.filter(
                (item) =>
                  !(
                    item.id === row.id &&
                    (item.type || item.pmc_type) == (row.type || row.pmc_type)
                  )
              )
              : [...prevList, { ...row, isAssigned: true }];

            const assignedData = updatedList.map(({ id, type, pmc_type }) => ({
              id,
              pmc_type: type || pmc_type,
            }));

            formik.setFieldValue("articulation_assign", assignedData);
            return updatedList;
          });
        };

        return (
          <div className="assessment-08">
            <div className="as-buttons">
              <button
                type="button"
                className={`btn rounded-circle ${isAssigned ? "btn-danger" : "btn-primary"
                  }`}
                onClick={handleAssign}
                title={isAssigned ? "Unassign Page" : "Assign Page"}
              >
                <i className={`fal fa-${isAssigned ? "minus" : "plus"}`}></i>
              </button>
            </div>
          </div>
        );
      },
    },
  ]);

  const sortingName = (rowA, rowB) => {
    const name1 = rowA.name ? rowA.name.toString() : "";
    const name2 = rowB.name ? rowB.name.toString() : "";
    return name1.localeCompare(name2);
  };

  const sortingCode = (rowA, rowB) => {
    const code1 = rowA.Code ? rowA.Code.toString() : "";
    const code2 = rowB.Code ? rowB.Code.toString() : "";
    return code1.localeCompare(code2);
  };

  const sortingProgrammeType = (rowA, rowB) => {
    const qualification_name1 = rowA.qualification_name
      ? rowA.qualification_name.toString()
      : "";
    const qualification_name2 = rowB.qualification_name
      ? rowB.qualification_name.toString()
      : "";
    return qualification_name1.localeCompare(qualification_name2);
  };

  const sortingType = (rowA, rowB) => {
    const type1 =
      rowA?.pmc_type || rowA?.type
        ? rowA?.type?.toString() || rowA?.pmc_type?.toString()
        : "";
    const type2 =
      rowB?.pmc_type || rowB?.type
        ? rowB?.type?.toString() || rowB?.pmc_type?.toString()
        : "";
    return type1.localeCompare(type2);
  };

  const ArticulationAssigncolumns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortFunction: sortingName,
      sortField: "name",
      sortable: true,
      cell: (row) => (
        <Link
          to={`/program-management-center/programmes/${row?.pmc_type === "0" ||
              row?.type === "0" ||
              row?.pmc_type === 0 ||
              row?.type === 0
              ? "programme"
              : "shortCourse"
            }/open/${row.id}`}
          title={row.name}
          className="as-text-blue curser feature-name"
        >
          <span title={row.name} className="textLimit100">
            {row.name}
          </span>
        </Link>
      ),
    },
    {
      name: "Code",
      selector: "Code",
      sortField: "Code",
      sortFunction: sortingCode,
      sortable: true,
      cell: (row) => (row.Code ? row.Code : "-"),
    },
    {
      name: "Status",
      selector: "status",
      sortField: "status",
      sortable: true,
      cell: (row) =>
        row.status != null ? RenderPMCStatus(row.status).html : "-",
    },
    {
      name: "Programme Type",
      selector: "Programme Type",
      sortField: "Programme Type",
      sortable: true,
      sortFunction: sortingProgrammeType,
      cell: (row) =>
        row.qualification_type != null
          ? RenderProgrammeType(row.qualification_type).html
          : "-",
    },
    {
      name: "Type",
      selector: "type",
      sortField: "pmc_type",
      sortable: true,
      sortFunction: sortingType,
      cell: (row) =>
        row?.pmc_type !== null && row?.pmc_type !== undefined
          ? RenderProgrammeOrCourseType(row.pmc_type).html
          : row?.type !== null && row?.type !== undefined
            ? RenderProgrammeOrCourseType(row.type).html
            : "-",
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <Link
              to={`/program-management-center/programmes/${row?.pmc_type === "0" ||
                  row?.type === "0" ||
                  row?.pmc_type === 0 ||
                  row?.type === 0
                  ? "programme"
                  : "shortCourse"
                }/open/${row.id}`}
              className="btn btn-primary rounded-circle"
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </Link>

            <button
              title="Delete"
              type="button"
              className="btn btn-danger rounded-circle"
              onClick={() => {
                setAssignedArticulationOptionList((prevList) => {
                  const updatedList = prevList?.filter((item) => {
                    const itemType = item.pmc_type || item.type;
                    const rowType = row.pmc_type || row.type;

                    return !(
                      item.id === row.id &&
                      itemType?.toString() === rowType?.toString()
                    );
                  });

                  const assignedData = updatedList?.map(
                    ({ id, type, pmc_type }) => ({
                      id,
                      pmc_type: type || pmc_type,
                    })
                  );

                  formik.setFieldValue("articulation_assign", assignedData);

                  return updatedList;
                });
              }}
            >
              <i className="fal fa-trash-alt"></i>
            </button>
          </div>
        </div>
      ),
    },
  ]);

  useEffect(() => {
    const payload = {
      exportStatus: "true",
    };

    GetPagesList(payload)
      .then((res) => {
        if (res.status == 200) {
          setAllPageListData(res.data?.Data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const exportAssignPageData = (fileType, fileName) => {
    let exportData = [...assignedArticulationOptionList];
    const header = ["Name", "Status", "brand templates"];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    const payload = {
      page: assignPageTableState.page,
      perPage: assignPageTableState.perPage,
      search: assignPageSearch,
      key: assignPageTableState.sortKey,
      sort: assignPageTableState.sortOrder,
      exportStatus: true,
      viaBrand: pageBrand.arr,
      viaStatus: pageStatus.arr,
    };
    GetPagesList(payload)
      .then((res) => {
        exportData = res.data.Data;
        exportData = exportData?.map((row) => ({
          ...row,
          Name: row?.PageTitle ? row?.PageTitle : "-",
          Status: row?.status ? row.status : "-",
          "brand templates":
            row?.brandTemplete?.length > 0
              ? row.brandTemplete.map((item) => item?.templateName).join(", ")
              : "-",
        }));

        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, exportData });
          const blob = new Blob([csvString], {
            type: "text/csv;charset=utf-8,",
          });

          const blobURL = window.URL.createObjectURL(blob);

          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = exportData.map((row) => {
            const obj = {};
            header.forEach((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });

          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = exportData.map((row) => {
            return [row["Name"], row["Status"], row["brand templates"]];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (!(dropDownValues?.programs)) {
    return <SkeletonLoaderBasic />;
  }

  const editorArr = [
    {
      name: "Programme Content",
      id: "one",
      component: (
        <HtmlInputEditor
          editorState={subjectContent}
          setEditorState={setSubjectContent}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.Description}
        />
      ),
      isInvalid: formik.errors.Description && formik.touched.Description,
    },
    {
      name: "Admission Requirements",
      id: "two",
      component: (
        <>
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="form-group-blk mb-3" title="Minimum Admission Requirement">
                <label htmlFor="min_admission_level">Minimum Admission Requirement</label>
                <Select
                  className="form-control custom-select-box"
                  name="min_admission_level"
                  value={minAdmissionLevelOptions.filter(
                    (option) => option.value === formik.values.min_admission_level
                  )}
                  onChange={(option) =>
                    formik.setFieldValue("min_admission_level", option ? option.value : "")
                  }
                  onBlur={formik.handleBlur}
                  options={minAdmissionLevelOptions}
                  maxMenuHeight={175}
                  placeholder="Select Minimum Admission Requirement"
                  isClearable
                />
              </div>
            </div>
          </div>
          <HtmlInputEditor
            editorState={admissionReq}
            setEditorState={setAdmissionReq}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.admission_req}
          />
        </>
      ),
      isInvalid: formik.errors.admission_req && formik.touched.admission_req,
    },
    {
      name: "Accreditation",
      id: "three",
      component: (
        <HtmlInputEditor
          editorState={accreditation}
          setEditorState={setAccreditation}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.accreditation}
        />
      ),
      isInvalid: formik.errors.accreditation && formik.touched.accreditation,
    },
    {
      name: "Articulation Option",
      id: "four",
      component: (
        <>
          <div className="mb-3">
            <DataTableComponentFrontPagination
              isInsidePopUp
              data={dataToRenderArticulationAssign()}
              columns={ArticulationAssigncolumns}
              exportData={exportDataAssignedArticulationOption}
              search={assignedArticulationSearch}
              setSearch={setAssignedArticulationSearch}
              exportFileName="Assigned_Students"
              tableButton={[
                <button
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#assignArticulationPopup"
                  title="Assign Articulation Option"
                  type="button"
                >
                  <i className="fal fa-plus"></i>Assign Articulation Option
                </button>,
              ]}
              filters={[
                {
                  filterName: " Status",
                  optionArr: assignedArticulationOptionFilterData.AssignStatus,
                  state: assignedStatus,
                  setState: setAssignedStatus,
                  renderLabelFunction: RenderPMCStatus,
                  uniqueId: "assignedStatus"
                },
                {
                  filterName: " Programme Type",
                  optionArr:
                    assignedArticulationOptionFilterData.AssignProgrammeType,
                  state: assignedProgType,
                  setState: setAssignedProgType,
                  uniqueId: "assignProgrammeType",
                  renderLabelFunction: RenderProgrammeType,
                },
                {
                  filterName: " Type",
                  optionArr: assignedArticulationOptionFilterData.AssignType,
                  state: assignedType,
                  setState: setAssignedType,
                  uniqueId: "assignType",
                  renderLabelFunction: RenderProgrammeOrCourseType,
                },
              ]}
            />
          </div>
          <label htmlFor="art_additional_info">Additional Information</label>
          <HtmlInputEditor
            editorState={articulationOption}
            setEditorState={setArticulationOption}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.articultion_option}
          />
        </>
      ),
      isInvalid:
        formik.errors.articultion_option && formik.touched.articultion_option,
    },
    {
      name: "Career Opportunities",
      id: "five",
      component: (
        <>
          <CareerPicker pmcId={type === "open" ? id : null} pmcType="programme" />
          <HtmlInputEditor
            editorState={careerOpportunity}
            setEditorState={setCareerOpportunity}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.career_opportunities}
          />
        </>
      ),
      isInvalid: false,
    },
    {
      name: "Stationery List",
      id: "six",
      component: (
        <HtmlInputEditor
          editorState={studyKit}
          setEditorState={setStudyKit}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.study_kit}
        />
      ),
      isInvalid: false,
    },
    {
      name: "Hardware/Device Requirements",
      id: "seven",
      component: (
        <>
          <div className="row">
            <div className="col-auto">
              <div className="form-group-blk mb-3">
                <label htmlFor="early_bird_discount">Laptop Options</label>
                <div className="d-flex">
                  <div className="custom-control custom-checkbox text-left">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="core_spec"
                      name="core_spec"
                      checked={formik.values.core_spec == 1}
                      onChange={() => {
                        if (formik.values.core_spec == 1) {
                          formik.setFieldValue("core_spec", 0);
                        } else {
                          formik.setFieldValue("core_spec", 1);
                        }
                      }}
                    />
                    <label className="custom-control-label" htmlFor="core_spec">
                      Core Spec
                    </label>
                  </div>
                  <div className="custom-control custom-checkbox text-left ml-2">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="med_spec"
                      name="med_spec"
                      checked={formik.values.med_spec == 1}
                      onChange={() => {
                        if (formik.values.med_spec == 1) {
                          formik.setFieldValue("med_spec", 0);
                        } else {
                          formik.setFieldValue("med_spec", 1);
                        }
                      }}
                    />
                    <label className="custom-control-label" htmlFor="med_spec">
                      Medium Spec
                    </label>
                  </div>
                  <div className="custom-control custom-checkbox text-left ml-2">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="high_spec"
                      name="high_spec"
                      checked={formik.values.high_spec == 1}
                      onChange={() => {
                        if (formik.values.high_spec == 1) {
                          formik.setFieldValue("high_spec", 0);
                        } else {
                          formik.setFieldValue("high_spec", 1);
                        }
                      }}
                    />
                    <label className="custom-control-label" htmlFor="high_spec">
                      High Spec
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <HtmlInputEditor
            editorState={hardwareReq}
            setEditorState={setHardwareReq}
            hideSign={true}
            belowNoMargin={true}
            isCKEditor={true}
            initialValue={detail.hardware_requirement}
          />
        </>
      ),
      isInvalid: false,
    },
    {
      name: "Pricing",
      id: "eight",
      component: (
        <>
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="form-group-blk mb-3">
                <label htmlFor="full_time_hybrid_fee">
                  Full Time, Hybrid Fee {formik.values.Delivery_Methods.includes("full") && "*"}
                </label>
                <div>
                  <span className="pricing-before-text">R</span>
                  <input
                    type="number"
                    className={
                      "input-price form-control" +
                      (formik.errors.full_time_hybrid_fee &&
                        formik.touched.full_time_hybrid_fee
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter Full Time, Hybrid Fee"
                    name="full_time_hybrid_fee"
                    id="full_time_hybrid_fee"
                    title="Full Time, Hybrid Fee"
                    value={formik.values.full_time_hybrid_fee}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="form-group-blk mb-3">
                <label htmlFor="full_time_online_fee">
                  Full Time, Online Fee {formik.values.Delivery_Methods.includes("fulltimeonline") && "*"}
                </label>
                <div>
                  <span className="pricing-before-text">R</span>
                  <input
                    type="number"
                    className={
                      "input-price form-control" +
                      (formik.errors.full_time_online_fee &&
                        formik.touched.full_time_online_fee
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter Full Time, Online Fee"
                    name="full_time_online_fee"
                    id="full_time_online_fee"
                    title="Full Time, Online Fee"
                    value={formik.values.full_time_online_fee}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="form-group-blk mb-3">
                <label htmlFor="part_time_online_fee">
                  Part Time, Online Fee {formik.values.Delivery_Methods.includes("parttimeonline") && "*"}
                </label>
                <div>
                  <span className="pricing-before-text">R</span>
                  <input
                    type="number"
                    className={
                      "input-price form-control" +
                      (formik.errors.part_time_online_fee &&
                        formik.touched.part_time_online_fee
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter Part Time, Online Fee"
                    name="part_time_online_fee"
                    id="part_time_online_fee"
                    title="Part Time, Online Fee"
                    value={formik.values.part_time_online_fee}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="form-group-blk mb-3">
                <label htmlFor="registration_fee">Minimum Deposit </label>
                <div>
                  <span className="pricing-before-text">R</span>
                  <input
                    type="number"
                    className={
                      "input-price form-control" +
                      (formik.errors.registration_fee &&
                        formik.touched.registration_fee
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter Minimum Deposit"
                    name="registration_fee"
                    id="registration_fee"
                    title="Minimum Deposit"
                    value={formik.values.registration_fee}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group-blk mb-3">
                <label htmlFor="cost_terms">Cost Terms</label>
                <input
                  className={
                    "form-control" +
                    (formik.errors.cost_terms && formik.touched.cost_terms
                      ? " is-invalid"
                      : "")
                  }
                  placeholder="Enter Cost Terms"
                  name="cost_terms"
                  id="cost_terms"
                  title="Cost Terms"
                  value={formik.values.cost_terms}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-auto">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="installments">Instalments</label>
                    <div className="d-flex">
                      {["2M", "3M", "6M", "10M", "12M", "18M", "24M"].map(
                        (option) => (
                          <div
                            className="custom-control custom-checkbox text-left ml-2"
                            key={option}
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={option}
                              name={option}
                              checked={formik.values.installments
                                .split(",")
                                .includes(option)}
                              onChange={() => handleChangeInstallments(option)}
                            />
                            <label
                              className="custom-control-label label-instalments"
                              htmlFor={option}
                            >
                              {option}
                            </label>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="early_bird_discount">
                      Early Bird Discount
                    </label>
                    <div className="d-flex">
                      <div className="custom-control custom-checkbox text-left">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="5_percent"
                          name="5_percent"
                          checked={formik.values.earlyBirds == 1}
                          onChange={() => {
                            if (formik.values.earlyBirds == 1) {
                              formik.setFieldValue("earlyBirds", "2");
                            } else {
                              formik.setFieldValue("earlyBirds", "1");
                            }
                          }}
                        />
                        <label
                          className="custom-control-label label-instalments"
                          htmlFor="5_percent"
                        >
                          5%
                        </label>
                      </div>
                      <div className="custom-control custom-checkbox text-left">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="10_percent"
                          name="10_percent"
                          checked={formik.values.earlyBirds == 0}
                          onChange={() => {
                            if (formik.values.earlyBirds == 0) {
                              formik.setFieldValue("earlyBirds", "2");
                            } else {
                              formik.setFieldValue("earlyBirds", "0");
                            }
                          }}
                        />
                        <label
                          className="custom-control-label label-instalments"
                          htmlFor="10_percent"
                        >
                          10%
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
      isInvalid: false,
    },
    {
      name: "Duration",
      id: "nine",
      component: (
        <HtmlInputEditor
          editorState={duration}
          setEditorState={setDuration}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.duration_dec}
        />
      ),
      isInvalid: false,
    },
    {
      name: "Regulatory Information",
      id: "ten",
      component: (
        <HtmlInputEditor
          editorState={regulatoryInfo}
          setEditorState={setRegulatoryInfo}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.regulatory_inform}
        />
      ),
      isInvalid: false,
    },
    {
      name: "Important Notes",
      id: "eleven",
      component: (
        <HtmlInputEditor
          editorState={impNotes}
          setEditorState={setImpNotes}
          hideSign={true}
          belowNoMargin={true}
          isCKEditor={true}
          initialValue={detail.important_notes}
        />
      ),
      isInvalid: false,
    },
  ];

  return (
    <>
      <div className="card card-profile-info-card filter-table-bg">
        <div className="new-card-header">
          <div className="card-header pt-0">Programme Information {loading ? <i className="fas fa-cog fa-spin" /> : ''} </div>
          <div className="card-body-inr card-body-info">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="name">Programme Name *</label>
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors["name"] && formik.touched["name"]
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter Programme Name"
                      name="name"
                      id="name"
                      title="Programme Name"
                      value={formik.values["name"]}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="name">SAQA ID</label>
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors["saqa_id"] &&
                          formik.touched["saqa_id"]
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter SAQA ID"
                      name="saqa_id"
                      id="saqa_id"
                      title="SAQA ID"
                      value={formik.values["saqa_id"]}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="name">SAQA Registered Name *</label>
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors["SAQA_Name"] &&
                          formik.touched["SAQA_Name"]
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter SAQA Name"
                      name="SAQA_Name"
                      id="SAQA_Name"
                      title="SAQA Registered Name"
                      value={formik.values["SAQA_Name"]}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3" title="School">
                    <label htmlFor="school">School *</label>
                    <Select
                      className={
                        "form-control custom-select-box " +
                        (formik.errors.School && formik.touched.School
                          ? " is-invalid"
                          : "")
                      }
                      name="School"
                      value={schoolList.filter(
                        (item) => item.value == formik.values.School
                      )}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue("School", value.value);
                        } else {
                          formik.setFieldValue("School", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      options={schoolList}
                      maxMenuHeight={175}
                      placeholder={"Select School"}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div
                    className="form-group-blk mb-3"
                    title="Qualification Type"
                  >
                    <label htmlFor="qualification_type">
                      Qualification Type *
                    </label>
                    <Select
                      className={
                        "form-control custom-select-box " +
                        (formik.errors.qualification_type &&
                          formik.touched.qualification_type
                          ? " is-invalid"
                          : "")
                      }
                      name="qualification_type"
                      value={dropDownValues?.programs.filter((item) => {
                        return item.value == formik.values.qualification_type;
                      })}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue(
                            "qualification_type",
                            value.value
                          );
                        } else {
                          formik.setFieldValue("qualification_type", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      options={dropDownValues?.programs}
                      maxMenuHeight={175}
                      placeholder={"Select Qualification Type"}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="code">Code</label>
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors.Code && formik.touched.Code
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter code"
                      name="Code"
                      id="Code"
                      title="Code"
                      value={formik.values.Code}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="SAQA_Link">
                      SAQA Link{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors["SAQA_Link"] &&
                          formik.touched["SAQA_Link"]
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter SAQA Link"
                      name="SAQA_Link"
                      id="SAQA_Link"
                      title="SAQA Link"
                      value={formik.values["SAQA_Link"]}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3" title="NQF Level">
                    <label htmlFor="NQF_Level">NQF Level *</label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (formik.errors.NQF_Level && formik.touched.NQF_Level
                          ? " is-invalid"
                          : "")
                      }
                      name="NQF_Level"
                      value={NQF_LevelArr.filter(
                        (val) => val?.value === formik.values.NQF_Level
                      )}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue("NQF_Level", value.value);
                        } else {
                          formik.setFieldValue("NQF_Level", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      options={NQF_LevelArr}
                      maxMenuHeight={175}
                      placeholder={
                        formik.values.NQF_Level
                          ? formik.values.NQF_Level
                          : "Select NQF Level  "
                      }
                      isClearable
                    />
                  </div>
                </div>
                <MultiSelectDropdown
                  name="Delivery_Methods"
                  label="Learning Methods"
                  value={dropDownValues?.study_type?.filter((item) =>
                    formik.values.Delivery_Methods?.includes(item.value)
                  )}
                  options={dropDownValues?.study_type}
                  onChange={(value) =>
                    formik.setFieldValue(
                      "Delivery_Methods",
                      value ? value.map((v) => v.value) : []
                    )
                  }
                  required={true}
                  col_md={6}
                  col_lg={3}
                  placeholder="Select Learning Methods"
                />
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="credit">
                      Credits <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <input
                      type="number"
                      className={
                        "form-control" +
                        (formik.errors.Credits && formik.touched.Credits
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter Credits"
                      name="Credits"
                      id="Credits"
                      title="Credits"
                      value={formik.values.Credits}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3">
                    <label htmlFor="Duration">Duration (Weeks)</label>
                    <input
                      type="number"
                      className={
                        "form-control" +
                        (formik.errors.Duration && formik.touched.Duration
                          ? " is-invalid"
                          : "")
                      }
                      placeholder="Enter Duration (Weeks)"
                      name="Duration"
                      id="Duration"
                      title="Duration (Weeks)"
                      value={formik.values.Duration}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3" title="Term Periods">
                    <label htmlFor="Term_Period">Term Periods</label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (formik.errors.Term_Period && formik.touched.Term_Period
                          ? " is-invalid"
                          : "")
                      }
                      name="Term_Period"
                      value={TermPeriods?.filter(
                        (val) => val.value === formik.values.Term_Period
                      )}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue("Term_Period", value.value);
                        } else {
                          formik.setFieldValue("Term_Period", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      id="Term_Period"
                      options={TermPeriods}
                      maxMenuHeight={175}
                      placeholder={
                        formik.values.Term_Period
                          ? formik.values.Term_Period
                          : "Select Term Period  "
                      }
                      isClearable
                    />
                  </div>
                </div>

                <CampusBuildingMultiSelect
                  value={formik.values.campusBuildings}
                  onChange={(value) => {
                    formik.setFieldValue("campusBuildings", value ? value : []);
                  }}
                  label="Locations"
                  required={true}
                  col_md={6}
                  col_lg={3}
                />
                
                {(id && formik.values.EnableStudypathLinkReReg) ?
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group-blk mb-3" title="Active Version">
                      <label htmlFor="version_id">Active Version {activeVersionList?.length > 0 && "*"}</label>
                      <Select
                        className={
                          "form-control custom-select-box" +
                          (formik.errors.version_id && formik.touched.version_id
                            ? " is-invalid"
                            : "")
                        }
                        name="version_id"
                        value={activeVersionList?.filter(
                          (val) => val.value === formik.values.version_id
                        )}
                        onChange={(value) => {
                          if (value) {
                            formik.setFieldValue("version_id", value.value);
                          } else {
                            formik.setFieldValue("version_id", "");
                          }
                        }}
                        onBlur={formik.handleBlur}
                        id="version_id"
                        options={activeVersionList}
                        maxMenuHeight={175}
                        placeholder={
                          formik.values.version_id
                            ? formik.values.version_id
                            : "Select Active Version"
                        }
                        isClearable
                      />
                    </div>
                  </div>
                  : null
                }
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="card-header pt-0">
                    <i
                      className="fal fa-cog"
                      style={{ color: "var(--topbar-color)" }}
                    ></i>{" "}
                    Programme Settings
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3" title="Netsuite Product">
                    <label>
                      Netsuite Product {" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (formik.errors.netsuite_product &&
                          formik.touched.netsuite_product
                          ? " is-invalid"
                          : "")
                      }
                      name="netsuite_product"
                      value={netsuiteProdList.filter(
                        (val) => val?.value == formik.values.netsuite_product
                      )}
                      onChange={(value) => {
                        if (value) {

                          formik.setFieldValue("netsuite_product", value.value);
                          formik.setFieldValue("netsuite_department_id", value.departmentId);
                        } else {
                          formik.setFieldValue("netsuite_product", "");
                          formik.setFieldValue("netsuite_department_id", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      options={netsuiteProdList}
                      maxMenuHeight={175}
                      placeholder={"Select Netsuite Product"}
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group-blk mb-3" title="Review Status">
                    <label>
                      Review Status *{" "}
                      <i className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <Select
                      className={
                        "form-control custom-select-box" +
                        (formik.errors.status && formik.touched.status
                          ? " is-invalid"
                          : "")
                      }
                      name="status"
                      value={statusArr.filter(
                        (val) => val?.value === formik.values.status
                      )}
                      onChange={(value) => {
                        if (value) {
                          formik.setFieldValue("status", value.value);
                        } else {
                          formik.setFieldValue("status", "");
                        }
                      }}
                      onBlur={formik.handleBlur}
                      options={statusArr}
                      maxMenuHeight={175}
                      placeholder={
                        formik.values.status
                          ? formik.values.status
                          : "Select Review Status  "
                      }
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 d-flex align-items-center">
                  <div
                    className="d-flex"
                    title="Activate Netsuite Integation"
                  >
                    <label className="mb-0">
                      Activate Netsuite Integation{" "}
                      <i title='This activates the link to netsuite, where new opportunities created will automatically be assigned to modules in the current active versions initial study path' className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={
                            formik.values.EnableStudypathLink === true
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              "EnableStudypathLink",
                              e.target.checked
                            );
                          }}
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3 d-flex align-items-center">
                  <div
                    className="d-flex"
                    title="Activate Programme Integration"
                  >
                    <label className="mb-0">
                      Activate Programme Integration{" "}
                      <i title='This activates the integration within AMI, enabling the modular re-reg workflow for linked programmes, gradebook and grade management within PMC as well as the QA integrations within PMC for linked programmes' className="fal fa-info-circle grade-icon"></i>
                    </label>
                    <div className="toggle-switch ml-2">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={
                            formik.values.EnableStudypathLinkReReg === true
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              "EnableStudypathLinkReReg",
                              e.target.checked
                            );
                          }}
                        />
                        <span className="slider slider-round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                {
                  formik.values.EnableStudypathLinkReReg === true && (
                    <>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group-blk mb-3">
                          <label htmlFor="credit">
                            Full Time, Minimum Module Count <i title="Minimum amount of modules a Full Time student can re-register for" className="fal fa-info-circle grade-icon"></i>
                          </label>
                          <input
                            type="number"
                            className={
                              "form-control" +
                              (formik.errors.FTMin && formik.touched.FTMin
                                ? " is-invalid"
                                : "")
                            }
                            placeholder="Enter Minimum Module Count"
                            name="FTMin"
                            id="FTMin"
                            title="FTMin"
                            value={formik.values.FTMin}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group-blk mb-3">
                          <label htmlFor="credit">
                            Full Time, Maximum Module Count <i title="Maximum amount of modules a Full Time student can re-register for" className="fal fa-info-circle grade-icon"></i>
                          </label>
                          <input
                            type="number"
                            className={
                              "form-control" +
                              (formik.errors.FTMax && formik.touched.FTMax
                                ? " is-invalid"
                                : "")
                            }
                            placeholder="Enter Maximum Module Count"
                            name="FTMax"
                            id="FTMax"
                            title="FTMax"
                            value={formik.values.FTMax}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group-blk mb-3">
                          <label htmlFor="credit">
                            Part Time, Minimum Module Count <i title="Minimum amount of modules a Part Time student can re-register for" className="fal fa-info-circle grade-icon"></i>
                          </label>
                          <input
                            type="number"
                            className={
                              "form-control" +
                              (formik.errors.PTMin && formik.touched.PTMin
                                ? " is-invalid"
                                : "")
                            }
                            placeholder="Enter Minimum Module Count"
                            name="PTMin"
                            id="PTMin"
                            title="PTMin"
                            value={formik.values.PTMin}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="form-group-blk mb-3">
                          <label htmlFor="credit">
                            Part Time, Maximum Module Count <i title="Maximum amount of modules a Part Time student can re-register for" className="fal fa-info-circle grade-icon"></i>
                          </label>
                          <input
                            type="number"
                            className={
                              "form-control" +
                              (formik.errors.PTMax && formik.touched.PTMax
                                ? " is-invalid"
                                : "")
                            }
                            placeholder="Enter Maximum Module Count"
                            name="PTMax"
                            id="PTMax"
                            title="PTMax"
                            value={formik.values.PTMax}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                          <div className="form-group-blk mb-3" title="Do students re-register annually? Or every semester?">
                            <label>
                              Re-Reg Frequency
                              <i className="fal fa-info-circle grade-icon"></i>
                            </label>
                            <Select
                              className={
                                "form-control custom-select-box" +
                                (formik.errors.reRegFrequency && formik.touched.reRegFrequency
                                  ? " is-invalid"
                                  : "")
                              }
                              name="reRegFrequency"
                              value={reRegFrequencyOptions.filter(
                                (val) => val?.value === formik.values.reRegFrequency
                              )}
                              onChange={(value) => {
                                if (value) {
                                  formik.setFieldValue("reRegFrequency", value.value);
                                } else {
                                  formik.setFieldValue("reRegFrequency", "");
                                }
                              }}
                              onBlur={formik.handleBlur}
                              options={reRegFrequencyOptions}
                              maxMenuHeight={175}
                              placeholder={
                                formik.values.reRegFrequency
                                  ? formik.values.reRegFrequency
                                  : "Select Re-Reg Frequency"
                              }
                              isClearable
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3 d-flex align-items-center">
                          <div
                            className="d-flex"
                            title="Articulation Mandatory"
                          >
                            <label className="mb-0">
                              Articulation Mandatory{" "}
                              <i title='Indicates articulation is mandatory, which will activate re-reg nurturing for graduates as well' className="fal fa-info-circle grade-icon"></i>
                            </label>
                            <div className="toggle-switch ml-2">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    formik.values.articulationMandatory === true
                                  }
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "articulationMandatory",
                                      e.target.checked
                                    );
                                  }}
                                />
                                <span className="slider slider-round"></span>
                              </label>
                            </div>
                          </div>
                      </div>
                    </>
                  )
                }
                {formik.values.override_default_tc ? (
                  <div className="col-md-6 col-lg-3">
                    <div className="d-flex align-items-start flex-column">
                      <label>
                        Assigned Terms & Conditions Page{" "}
                        {formik.values.override_default_tc && "*"}{" "}
                        <i className="fal fa-info-circle grade-icon"></i>
                      </label>
                      <button
                        className={
                          "btn btn-save btn-success" +
                          (formik.errors.terms_conditions_page &&
                            formik.touched.terms_conditions_page
                            ? " file-req is-invalid"
                            : "")
                        }
                        type="button"
                        title="Assign Page"
                        data-toggle="modal"
                        data-target="#assignPagePopup"
                      >
                        <i className="fal fa-plus"></i> Assign Page
                      </button>
                      {formik.values.terms_conditions_page
                        ? allpageListData
                          ?.filter(
                            (page) =>
                              page.PageID ===
                              formik.values.terms_conditions_page
                          )
                          .map((assignedPage) => (
                            <div
                              className="frm-group w-100"
                              key={assignedPage.PageID}
                            >
                              <ul className="list-unstyled attached-file-ul m-0">
                                <li>
                                  <a
                                    target="_blank"
                                    href={`/website_management/pages/staticpages/table/update/${assignedPage.PageID}`}
                                  >
                                    <span
                                      className="textLimit100 as-text-blue w-100"
                                      title={assignedPage.PageTitle}
                                    >
                                      {TrimText(assignedPage.PageTitle, 30)}
                                    </span>
                                  </a>
                                  <button
                                    className="btn btn-danger rounded-circle btn-dropdown-item"
                                    title="Delete"
                                    onClick={() => {
                                      formik.setFieldValue(
                                        "terms_conditions_page",
                                        ""
                                      );
                                    }}
                                  >
                                    <i className="fal fa-trash-alt"></i>
                                  </button>
                                </li>
                              </ul>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                ) : null}
              </div>
              <div
                className="admin-home-acc accordion ac_over_none"
                id="accordionExample"
              >
                {editorArr.map((item, index) => {
                  return (
                    <div className="card-main" key={index}>
                      <div className="card-top">
                        <div className="card-header1" id={`heading${item.id}`}>
                          <h2 className="mb-0">
                            <button
                              className="btn-link collapsed"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapse${item.id}`}
                              aria-expanded="false"
                              aria-controls={`collapse${item.id}`}
                            >
                              <div
                                className={`title-border-box ${item.isInvalid ? "editor-block-invalid" : ""
                                  } `}
                              >
                                {item.name}
                              </div>

                              <div className="header-status">
                                <div className="status-gol card-blue-1">
                                  <i className="fal fa-chevron-down rotate-icon"></i>
                                </div>
                              </div>
                            </button>
                          </h2>
                        </div>
                        <div
                          id={`collapse${item.id}`}
                          className="card-body1 mt-2 collapse"
                          aria-labelledby={`heading${item.id}`}
                          data-parent="#accordionExample"
                        >
                          <div className="card-body inner-tab-card">
                            {(editorToShow || type == "add") && item.component}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <hr />
              <div className="form-group form-group-save-cancel mt-4">
                <button
                  className="btn btn-save btn-success"
                  type="submit"
                  title="Save"
                  disabled={false}
                  onClick={formik.handleSubmit}
                >
                  {disabled ? (
                    <i className="fas fa-cog fa-spin"></i>
                  ) : (
                    <i className="fal fa-save"></i>
                  )}
                  Save
                </button>

                <button
                  className="btn btn-close btn-danger"
                  type="button"
                  title="Cancel"
                  onClick={() => handlereset()}
                >
                  <i className="fal fa-times"></i>Cancel
                </button>
              </div>
              {/** map function to render all errors  */}
              {Object.keys(formik.values).map((key) => {
                if (formik.touched[key] && formik.errors[key]) {
                  return (
                    <div className="invalid-feedback d-block" key={key}>
                      {formik.errors[key]}
                    </div>
                  );
                }
              })}
            </form>
          </div>
        </div>
      </div>
      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignPagePopup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered available-assessment-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-plus"></i> Assign Page
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <DataTableComponent
                data={assignPageList}
                loading={assignPageLoading}
                state={assignPageTableState}
                setState={setAssignPageTableState}
                setSearch={setAssignPageSearch}
                totalRows={assignPageTotalRows}
                columns={assignPageColumn}
                exportFunction={exportAssignPageData}
                exportFileName={"Assign_Page"}
                isInsidePopUp={true}
                filters={[
                  {
                    filterName: "Status",
                    optionArr: PageFilterData.status,
                    state: pageStatus,
                    setState: setPageStatus,
                    renderLabelFunction: RenderPMCPageStatus,
                  },

                  {
                    filterName: "Brand Templates",
                    optionArr: PageFilterData.BrandList,
                    state: pageBrand,
                    isOptionReversed: false,
                    stopOptionSorting: true,
                    setState: setPageBrand,
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignArticulationPopup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered available-assessment-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-plus"></i> Assign Articulation Options
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <DataTableComponent
                data={articulationOptionList}
                columns={articulationOptionColumn}
                loading={articulationOptionLoading}
                search={articulationOptionSearch}
                setSearch={setArticulationOptionSearch}
                state={articulationOptionTableState}
                setState={setArticulationOptionTableState}
                totalRows={articulationOptionTotalRow || 0}
                exportFunction={exportDataArticulationOption}
                exportFileName={"Articulation_Option"}
                isInsidePopUp={true}
                keyField="ref_id"
                filters={[
                  {
                    filterName: "Status",
                    optionArr: articulationOptionFilterData.status,
                    state: artStatus,
                    setState: setArtStatus,
                    renderLabelFunction: RenderPMCStatus,
                  },
                  {
                    filterName: "Programme Type",
                    optionArr: articulationOptionFilterData.programmeType,
                    state: artProgType,
                    setState: setArtProgType,
                    renderLabelFunction: RenderProgrammeType,
                  },
                  {
                    filterName: "Type",
                    optionArr: articulationOptionFilterData.type,
                    state: artType,
                    setState: setArtType,
                    renderLabelFunction: RenderProgrammeOrCourseType,
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgramDetail;
